<template>
  <div>
    <textarea v-model="currentText" @input="onInput" :rows="rows" :placeholder="placeholder" autofocus ref="textarea"
              :style="{lineHeight:lineHeight+'px',fontSize:fontSize+'px'}">
      </textarea>
    <div class="hide-box">
      <div class="show-box" ref="showBox" v-html="highLight(currentText)">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "w-textarea",
    props: {
      value: {
        type: String,
        default: ""
      },
      placeholder: {
        type: String,
        default: ""
      },
      lineHeight: {
        type: [Number, String],
        default: 20
      },
      fontSize: {
        type: [Number, String],
        default: 14
      },
      maxLength: {
        type: [Number],
        default: 300
      }
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    data() {
      return {
        currentText: "",
        height: 0
      }
    },
    computed: {
      rows() {
        let height = this.height
        if (height <= 20) {
          return 1
        } else if (height <= 40 && height > 20) {
          return 2
        } else if (height <= 60 && height > 40) {
          return 3
        } else if (height > 60) {
          return 4
        }
      }
    },
    mounted() {
      this.currentText = this.value
      this.height = this.lineHeight
    },
    watch: {
      currentText() {
        this.onInput()
      },
      value(val){
        this.currentText = val
      }
    },
    methods: {
      highLight(content) {
        let arr = []
        let con = content.split('\n').forEach(item => arr.push(`<p style="min-height: ${this.lineHeight}px">${item.trim()}</p>`))
        return arr.join('')
      },
      onInput(e) {
        let box = this.$refs.showBox
        if (this.currentText.length > this.maxLength) {
          this.$createToast({
            txt: '超出评论字数限制',
            time: 1500,
            type: 'txt'
          }).show()
          setTimeout(() => {
            this.currentText = this.currentText.slice(0, this.maxLength)
            this.$emit('input', this.currentText)
          }, 100)
          return
        }
        this.$emit('input', this.currentText)
        this.$nextTick(() => {
          setTimeout(() => {
            this.height = (this.$refs.showBox && this.$refs.showBox.offsetHeight || 20)
          }, 100)
        })
      },
      onFocus() {
        this.$refs.textarea.focus()
      }
    }
  }
</script>

<style lang="scss" scoped>
  textarea {
    width: 100%;
    outline: none;
    resize: none;
    border: none;
    transition: all .3s;

    &::placeholder {
      color: #BCBCBC;
    }
  }

  .hide-box {
    overflow: hidden;
    height: 0px;
  }

  /deep/ p {
    width: 100%;
    word-wrap: break-word;
  }
</style>